<template>
  <v-row dense>
    <!-- Date Picker -->
    <v-col cols="12" sm="4">
      <v-menu
        v-model="menuDate"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="formattedDate"
            label="Delivery Date"
            outlined
            dense
            readonly
            hide-details
            clearable
            @click:clear="clearDate"
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="date"
          @change="menuDate = false"
          :min="minDate"
        />
      </v-menu>
    </v-col>

    <!-- Start Time Picker -->
    <v-col cols="12" sm="4">
      <v-menu
        v-model="menuStartTime"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="formattedStartTime"
            label="Start Time"
            outlined
            dense
            hide-details
            readonly
            clearable
            @click:clear="clearStartTime"
            v-on="on"
          />
        </template>
        <v-time-picker
          v-model="startTime"
          format="ampm"
          @change="menuStartTime = false"
        />
      </v-menu>
    </v-col>

    <!-- End Time Picker -->
    <v-col cols="12" sm="4">
      <v-menu
        v-model="menuEndTime"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="formattedEndTime"
            label="End Time"
            outlined
            dense
            readonly
            hide-details
            clearable
            :disabled="!startTime"
            @click:clear="clearEndTime"
            v-on="on"
            :error="endTime && !isEndTimeValid"
            :error-messages="
              endTime && !isEndTimeValid
                ? ['End time must be after start time']
                : []
            "
          />
        </template>
        <v-time-picker
          v-model="endTime"
          format="ampm"
          @change="menuEndTime = false"
        />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    initValue: Object,
    resetKey: {
      type: [String, Number], // can be timestamp or unique string
      default: null,
    },
  },
  data() {
    return {
      date: null,
      startTime: "",
      endTime: "",
      menuDate: false,
      menuStartTime: false,
      menuEndTime: false,
      minDate: this.$moment().format("YYYY-MM-DD"), // Today as minimum selectable date
    };
  },
  // created() {
  //   // if (this.initValue) {
  //   //   console.log("initValue", this.initValue);
  //   //   const { date, startTime, endTime } = this.initValue;
  //   //   this.date = date || "";
  //   //   this.startTime = startTime || "";
  //   //   this.endTime = endTime || "";
  //   // }
  //   this.date = date
  //     ? this.$moment.utc(date).isValid()
  //       ? this.$moment.utc(date).format("YYYY-MM-DD")
  //       : null
  //     : null;
  // },
  watch: {
    // initValue(newVal) {
    //   if (newVal) {
    //     const { date, startTime, endTime } = newVal;
    //     this.date = date || "";
    //     this.startTime = startTime || null;
    //     this.endTime = endTime || null;
    //   }
    initValue(newVal) {
      if (newVal) {
        const { date, startTime, endTime } = newVal;
        this.date = date || "";
        this.startTime = this.isValidTime(startTime) ? startTime : "";
        this.endTime = this.isValidTime(endTime) ? endTime : "";
        this.date =
          typeof date === "string" || date instanceof Date
            ? this.$moment.utc(date).format("YYYY-MM-DD")
            : null;
      }
    },
    resetKey() {
      this.resetFields();
    },
    date() {
      this.emitValue();
    },
    startTime(newVal) {
      if (newVal) {
        // Set end time to 90 minutes after start time
        const end = this.$moment(newVal, "HH:mm").add(90, "minutes");
        this.endTime = end.format("HH:mm");
      } else {
        this.endTime = "";
      }
      this.emitValue();
    },
    endTime() {
      this.emitValue();
    },
  },
  computed: {
    formattedDate() {
      // return this.date ? this.$moment(this.date).format("MM/DD/YYYY") : "";
      return this.date ? this.$moment.utc(this.date).format("MM/DD/YYYY") : "";
    },
    // formattedStartTime() {
    //   return this.startTime
    //     ? this.$moment(this.startTime, "HH:mm").format("hh:mm A")
    //     : "";
    // },
    // formattedEndTime() {
    //   return this.endTime
    //     ? this.$moment(this.endTime, "HH:mm").format("hh:mm A")
    //     : "";
    // },
    formattedStartTime() {
      if (!this.startTime) return "";
      const m = this.$moment(this.startTime, "HH:mm");
      return m.isValid() ? m.format("hh:mm A") : "";
    },
    formattedEndTime() {
      if (!this.endTime) return "";
      const m = this.$moment(this.endTime, "HH:mm");
      return m.isValid() ? m.format("hh:mm A") : "";
    },
    isEndTimeValid() {
      if (!this.startTime || !this.endTime) return true;
      const start = this.$moment(this.startTime, "HH:mm");
      const end = this.$moment(this.endTime, "HH:mm");
      return end.isAfter(start);
    },
  },
  methods: {
    isValidTime(value) {
      if (!value || typeof value !== "string") return false;
      const m = this.$moment(value, "HH:mm", true);
      return m.isValid();
    },
    resetFields() {
      this.date = "";
      this.startTime = "";
      this.endTime = "";
      this.emitValue(); // emit empty state to parent
    },
    emitValue() {
      this.$emit("input", {
        date: this.date,
        startTime: this.startTime,
        endTime: this.endTime,
      });
    },
    clearDate() {
      this.date = "";
    },
    clearStartTime() {
      this.startTime = "";
      this.endTime = "";
    },
    clearEndTime() {
      this.endTime = "";
    },
  },
};
</script>

<style scoped></style>